"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyStructure = void 0;
var CompanyStructure;
(function (CompanyStructure) {
    CompanyStructure["None"] = "None";
    CompanyStructure["SoleProprietorship"] = "SoleProprietorship";
    CompanyStructure["LlcSingleMember"] = "LlcSingleMember";
    CompanyStructure["LlcMultiMember"] = "LlcMultiMember";
    CompanyStructure["CorporationS"] = "CorporationS";
    CompanyStructure["LLCCorporationS"] = "LLCCorporationS";
    CompanyStructure["LLCCorporationC"] = "LLCCorporationC";
    CompanyStructure["LLCPartnership"] = "LLCPartnership";
    CompanyStructure["CorporationC"] = "CorporationC";
    CompanyStructure["Partnership"] = "Partnership";
})(CompanyStructure = exports.CompanyStructure || (exports.CompanyStructure = {}));
//# sourceMappingURL=company.js.map